<template>
  <section>
    <div id="sectionCont">
      <div class="card" :class=" { 'card-1-active': zoneIsActive, 'card-1-deactive': zoneNotActive }">
        <img class="icon" src="../../assets/cardIcons/handshakeCard_250x250.svg" alt="Handshake Icon" />
        <div class="textCont">
          <h2>
            <span>QUALITY</span> SERVICE
          </h2>
          <div>
            Owned and operated by Jeremy Berg, Berg Enterprises, LLC prides itself on exceptional
            service and collaborative solution building. Our goals are to build sustainable and
            reliable IT solutions as well as ensuring our own availability for our customers at
            a moment's notice. 
           </div>
        </div>
      </div>
      <div class="card reverse" :class=" { 'card-2-active': zoneIsActive, 'card-2-deactive': zoneNotActive } ">
        <img class="icon" src="../../assets/cardIcons/networkCard_250x250.svg" alt="Network Icon" />
        <div class="textCont">
           <h2>
             <span>MODERN</span> SOLUTIONS
          </h2>
          <div>
            There have never been more technology options available! As adventageous as this is,
             it can make finding the right IT solution difficult. Berg Enterprises makes building a
            custom tech solution easy, so you can focus less on the technical details, and more
            on running your business.
          </div>
        </div>
      </div>
      <div class="card" :class=" { 'card-3-active': zoneIsActive, 'card-3-deactive': zoneNotActive } ">
        <img class="icon" src="../../assets/cardIcons/MN_250x250.svg" alt="Minnesota Icon" />
        <div class="textCont">
           <h2>
             <span>MINNESOTA</span>-BASED
          </h2>
          <div>
            Our home is in St. Michael, MN, and we serve the greater Twin Cities area. Our customers range
            from educators, to manufacturers, to designers, and more all throughout Minneapolis/St. Paul.
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  
  export default {
    name: 'AboutSection',
    
    components: {
      
    },
    
    data() {
      return {
        
      }
    },
    
    computed: {
      zoneIsActive() {
        return this.$store.state.activeSections.about;
      },
      zoneNotActive() {
        return !this.$store.state.activeSections.about;
      }
    },
    
    methods: {
      
    }
  }
  
</script>

<style scoped>
  section {
    width: 100%;
    min-width: 320px;
    min-height: 100vh;
    height: auto;
    border: solid blue 0px;
    display: flex; 
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: var(--bg-main);
    transition: background-position, 400ms;
    position: relative;
  }
  
  #sectionCont {
    border: solid yellow 0px;
    max-width: 800px;
    min-width: 320px;
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    margin: 60px 0px 0px 0px;
  }
  
  .card {
    border: dotted blue 0px;
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    opacity: 1;
    color: rgb(0, 0, 0);
    transition: all 500ms cubic-bezier(.47,0,.2,1);
  }

  .card-1-active {
    opacity: 1;
    transform: translateX(0px);
    transition-delay: 100ms;
  }
  
  .card-1-deactive {
    transform: translateX(-200px);
    opacity: 0;
  }
  
  .card-2-active {
    opacity: 1;
    transform: translateX(0px);
    transition-delay: 200ms;
  }
  
  .card-2-deactive {
    transform: translateX(200px);
    opacity: 0;
  }
  
  .card-3-active {
    opacity: 1;
    transform: translateX(0px);
    transition-delay: 300ms;
  }
  
  .card-3-deactive {
    transform: translateX(-200px);
    opacity: 0;
  }

  .reverse {
    flex-direction: row-reverse;
  }
  
  .icon {
    min-width: 250px;
    min-height: 250px;
    max-width: 250px;
    max-height: 250px;
    width: 40vmin;
    height: 40vmin;
    margin: 20px 20px 20px 20px;
  }

  .textCont {
    border: solid green 0px;
    margin: 40px 40px 40px 40px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  span {
    color: rgb(103, 35, 184);
    font-weight: bold;
  }

  h2 {
    font-family: Futura,Trebuchet MS,Arial,sans-serif;
    font-weight: normal;
    font-size: 34px;
    border: solid yellow 0px;
    position: relative;
    text-shadow: 0px 2px 4px rgba(0, 0, 0, .2);
    margin: 0px 0px 8px 0px;
  }

  @media screen and (max-width: 800px) {
    
    .card {
      flex-direction: column;
      margin: 0px 0px 0px 0px;
      transition: all 500ms cubic-bezier(.47,0,.2,1);
    }
    
    .card-1-active {
      transform: translateY(0px);
      opacity: 1;
      transition-delay: 100ms;
    }
    
    .card-1-deactive {
      flex-direction: column;
      transform: translateY(100px);
      opacity: 0;
    }
    
    .card-2-active {
      transform: translateY(0px);
      opacity: 1;
      transition-delay: 200ms;
    }
    
    .card-2-deactive {
      flex-direction: column;
      transform: translateY(100px);
      opacity: 0;
    }
    
    .card-3-active {
      transform: translateY(0px);
      opacity: 1;
      transition-delay: 300ms;
    }
    
    .card-3-deactive {
      flex-direction: column;
      transform: translateY(100px);
      opacity: 0;
    }

    .textCont {
      align-items: center;
      justify-content: center;
      flex-direction: column;
      transform: translateY(-20px);
      margin: 0px 40px 0px 40px;
      text-align: center;
    }

    .icon {
      min-width: 180px;
      min-height: 180px;
      margin: 0px;
    }

    h2 {
      margin: 20px 0px 20px 0px;
    }
  }
  
  @media screen and (max-width: 450px) {
    
    h2 {
      font-size: 7vw;
      text-align: center;
    }
  }

</style>